var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",attrs:{"id":"promotion-banner"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.promotion.banner}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }